module.exports = __webpack_public_path__ + "img/image--about-system.c71037e3.svg";